import Card from "components/card";

const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="!flex-row p-4 items-center rounded-xl hover:shadow-lg transition-all duration-300 overflow-hidden ">
      <div className="flex h-[90px] w-auto flex-row items-center">
        <div className="h-full w-2 bg-primary"></div>
        <div className="ml-4 rounded-full bg-primary/10 p-3.5 dark:bg-navy-700">
          <span className="flex items-center text-primary dark:text-white">
            {icon}
          </span>
        </div>
      </div>

      <div className="ml-4 flex w-auto flex-col justify-center">
        <p className="mb-1 text-sm font-medium text-gray-600 dark:text-gray-400">
          {title}
        </p>
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
